import { trackInteraction } from 'client/javascript/analytics';

export const INTERACTION_LABELS = {
  PROMO_BANNER_LINK_LABEL: 'Click - Homepage Takeover Module'
};
export const SELECTORS = {
  PROMO_BANNER_LINK: '.analytics-homepage-promo-link'
};

export const setupPromoModuleAnalytics = (moduleDomNode) => {
  const linkNode = moduleDomNode.querySelector(SELECTORS.PROMO_BANNER_LINK);

  if (linkNode) {
    linkNode.addEventListener('click', () => {
      trackInteraction({ label: INTERACTION_LABELS.PROMO_BANNER_LINK_LABEL });
    });
  }
};
